import { Platform, Pressable, StyleSheet, View } from 'react-native';
import { useTranslation } from 'react-i18next';

import { Container, Text } from '@/components/ui';
import { changeLocale, type Locale } from '@/lib/i18n';
import { useTheme } from '@/theme';

export function UtilityBar() {
  const { i18n, t } = useTranslation();
  const theme = useTheme();
  const locale = (i18n.language?.startsWith('en') ? 'en' : 'de') as Locale;

  const setLocale = (next: Locale) => {
    if (i18n.language !== next) void changeLocale(next);
  };

  return (
    <View style={[styles.bar, { borderBottomColor: theme.colors.rule, backgroundColor: theme.colors.bg }]}>
      <Container>
        <View style={styles.row}>
          <View style={styles.lang}>
            <LangBtn label={t('common.language.de')} active={locale === 'de'} onPress={() => setLocale('de')} />
            <Text style={[styles.bullet, { color: theme.colors.fgMute }]}>·</Text>
            <LangBtn label={t('common.language.en')} active={locale === 'en'} onPress={() => setLocale('en')} />
          </View>
          <View style={styles.where}>
            <Text style={[styles.cell, { color: theme.colors.fgSoft, fontFamily: theme.fontFamily.mono }]}>
              {t('common.utility.studio')}
            </Text>
            <Text
              style={[
                styles.cell,
                styles.hideMobile,
                { color: theme.colors.fgSoft, fontFamily: theme.fontFamily.mono },
              ]}
            >
              {t('common.utility.hours')}
            </Text>
            <Text style={[styles.cell, { color: theme.colors.fgSoft, fontFamily: theme.fontFamily.mono }]}>
              {t('common.utility.phone')}
            </Text>
          </View>
        </View>
      </Container>
    </View>
  );
}

function LangBtn({ label, active, onPress }: { label: string; active: boolean; onPress: () => void }) {
  const theme = useTheme();
  return (
    <Pressable accessibilityRole="button" onPress={onPress} style={styles.langBtn}>
      <Text
        style={{
          fontFamily: theme.fontFamily.mono,
          fontSize: 11,
          letterSpacing: 1.5,
          textTransform: 'uppercase',
          color: active ? theme.colors.fg : theme.colors.fgMute,
        }}
      >
        {label}
      </Text>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  bar: {
    borderBottomWidth: 1,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 42,
    flexWrap: 'wrap',
    gap: 8,
  },
  lang: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 2,
  },
  langBtn: {
    paddingHorizontal: 8,
    paddingVertical: 4,
  },
  bullet: {
    fontFamily: 'JetBrainsMono_400Regular',
    fontSize: 11,
    paddingHorizontal: 2,
  },
  where: {
    flexDirection: 'row',
    gap: 18,
    flexWrap: 'wrap',
  },
  cell: {
    fontSize: 11,
    letterSpacing: 1.5,
    textTransform: 'uppercase',
  },
  hideMobile: {},
});
